export default __webpack_public_path__ + "static/media/email-illustration.84fb82b8.svg";